// VCIN Brand: Always use VCIN_COLORS from constants.js - never use Tailwind blue classes
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, Building2, Users, Eye, Car, 
  ScrollText, User, LogOut, BarChart3
} from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { VCIN_COLORS } from '../../styles/constants';

const navItems = [
  { path: '/super-admin', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { path: '/super-admin/companies', icon: Building2, label: 'Companies' },
  { path: '/super-admin/officers', icon: Users, label: 'Officers' },
  { path: '/super-admin/sightings', icon: Eye, label: 'Sightings' },
  { path: '/super-admin/vehicles', icon: Car, label: 'Vehicles' },
  { path: '/super-admin/statistics', icon: BarChart3, label: 'Statistics' },
  { path: '/super-admin/audit-log', icon: ScrollText, label: 'Audit Log' },
  { path: '/super-admin/account', icon: User, label: 'Account' }
];

export default function SuperAdminSidebar() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => navigate('/signout');

  return (
    <aside 
      className="fixed left-0 top-0 h-full w-64 flex flex-col"
      style={{ backgroundColor: VCIN_COLORS.primary }}
      data-testid="super-admin-sidebar"
    >
      {/* Logo */}
      <div className="p-6 border-b border-white/10">
        <div className="flex items-center gap-3">
          <div 
            className="w-10 h-10 rounded-lg flex items-center justify-center font-bold text-lg"
            style={{ backgroundColor: VCIN_COLORS.gold, color: VCIN_COLORS.primary }}
          >
            V
          </div>
          <div>
            <h1 className="text-white font-bold text-lg">VCIN</h1>
            <p className="text-white/60 text-xs">Super Admin</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-4 overflow-y-auto">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.end}
            className={({ isActive }) => `
              flex items-center gap-3 px-6 py-3 text-sm font-medium transition-all
              ${isActive 
                ? 'text-white bg-white/10' 
                : 'text-white/70 hover:text-white hover:bg-white/5'
              }
            `}
            style={({ isActive }) => isActive ? { 
              borderLeft: `3px solid ${VCIN_COLORS.gold}`,
              paddingLeft: '21px'
            } : {}}
            data-testid={`nav-sa-${item.label.toLowerCase().replace(' ', '-')}`}
          >
            <item.icon className="w-5 h-5" />
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* Sign Out */}
      <div className="p-4 border-t border-white/10">
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 w-full px-4 py-3 text-sm font-medium text-white/70 hover:text-white hover:bg-white/5 rounded-lg transition-all"
          data-testid="super-admin-logout-btn"
        >
          <LogOut className="w-5 h-5" />
          Sign Out
        </button>
      </div>
    </aside>
  );
}
